/* @flow */

import EventEmitter from 'events';

// Unlimited number of listeners
const MAX_LISTENERS = 0;

type CallbackFunction = (...args: Array<any>) => void | Promise<void>;

class Messenger extends EventEmitter {
  static instance: Messenger;

  constructor() {
    super();
    this.setMaxListeners(MAX_LISTENERS);
  }

  // $FlowFixMe[unsupported-syntax] Flow does not support symbols yet
  get [Symbol.toStringTag]() {
    return 'Messenger';
  }

  static getInstance: () => Messenger = () => {
    if (!Messenger.instance) {
      Messenger.instance = new Messenger();
    }

    return Messenger.instance;
  };

  static on: (eventName: string, callback: CallbackFunction) => void = (eventName, callback) => {
    Messenger.getInstance().on(eventName, callback);
  };

  static once: (eventName: string, callback: CallbackFunction) => void = (eventName, callback) => {
    Messenger.getInstance().once(eventName, callback);
  };

  static off: (eventName: string, callback: CallbackFunction) => void = (eventName, callback) => {
    Messenger.getInstance().off(eventName, callback);
  };

  static emit: (eventName: string, ...args: Array<any>) => void = (eventName, ...args) => {
    Messenger.getInstance().emit(eventName, ...args);
  };
}

export default Messenger;
